'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_ControlStep(icon, title, text) {
  this.h6 = null;
  this.h8 = null;
  this.h7 = null;
  this.h6 = icon;
  this.h8 = title;
  this.h7 = text;
}
export { $c_Lio_intela_sites_intelacloud_content_ControlStep as $c_Lio_intela_sites_intelacloud_content_ControlStep };
$p = $c_Lio_intela_sites_intelacloud_content_ControlStep.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_ControlStep;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_ControlStep() {
}
export { $h_Lio_intela_sites_intelacloud_content_ControlStep as $h_Lio_intela_sites_intelacloud_content_ControlStep };
$h_Lio_intela_sites_intelacloud_content_ControlStep.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-2017386220), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_ControlStep)) {
    var x = this.h6;
    var x$2 = x$0.h6;
    if (((x === x$2) && (this.h8 === x$0.h8))) {
      return (this.h7 === x$0.h7);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "ControlStep";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.h6;
      break;
    }
    case 1: {
      return this.h8;
      break;
    }
    case 2: {
      return this.h7;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_ControlStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bs)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_ControlStep as $isArrayOf_Lio_intela_sites_intelacloud_content_ControlStep };
var $d_Lio_intela_sites_intelacloud_content_ControlStep = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_ControlStep, "io.intela.sites.intelacloud.content.ControlStep", ({
  bs: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_ControlStep as $d_Lio_intela_sites_intelacloud_content_ControlStep };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Control-Step.js.map
